import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormService } from 'src/app/services/forms/form.service';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsletterComponent implements OnInit {
@ViewChild ('subscribeForm') subscribeForm!: NgForm;


  constructor(private formService: FormService) { }

  ngOnInit(): void {
  }

  onSubscription(form: {
    name: string,
    email: string
  }){
    
    this.formService.postSubscriber(form).subscribe((res)=> {
      this.subscribeForm.resetForm()
    })
  }

}
